import { ledgerApi } from '../../../api';
import type { GameStateSetter } from '../types';

export const createFetchLedger = (set: GameStateSetter) => {
  return async (boardId: string): Promise<void> => {
    set({ isLoadingLedger: true, ledgerError: null, boardId });
    try {
      const [entries, summary] = await Promise.all([
        ledgerApi.getEntries(boardId),
        ledgerApi.getSummary(boardId),
      ]);
      set({ ledgerEntries: entries, ledgerSummary: summary, isLoadingLedger: false });
    } catch (err) {
      set({
        ledgerError: err instanceof Error ? err.message : 'Failed to fetch ledger',
        isLoadingLedger: false,
      });
    }
  };
};
